import { FILE_TYPE_MAPPING } from "./mediaFileExtensions";

export interface ValidationResult {
  isValidType: boolean;
  isValidSize: boolean;
}

export const normalizeFileExtension = (fileType: string): string => {
  const validExt = fileType.split("/");
  const extension = validExt[1];
  return FILE_TYPE_MAPPING[extension] || extension;
};

export const validateFileTypeAndSize = (
  fileType: string,
  fileSize: number,
  allowedExtensions: string,
  maxFileSize: number
): ValidationResult => {
  const normalizedExt = normalizeFileExtension(fileType);
  const isValidType = allowedExtensions?.includes(normalizedExt);
  const isValidSize = fileSize <= maxFileSize;

  return {
    isValidType,
    isValidSize,
  };
};
